import request from '@/utils/request'

const url = 'admin/coach.coach'
/**
 * 教练表接口API
 */

const api = {
  Query(data) {
    return request({
      url: `${url}/list`,
      method: 'post',
      data
    })
  },

  /**
     * 添加Coach
     * @returns
     */
  Create(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 编辑Coach
     * @returns
     */
  Update(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 详情Coach
     * @returns
     */
  Detail(id) {
    return request({
      url: `${url}/detail`,
      method: 'post',
      params: { id }
    })
  },

  /**
     * 删除Coach
     * @returns
     */
  Delete(data) {
    return request({
      url: `${url}/destroy`,
      method: 'post',
      data
    })
  },

  /**
   * 更改Coach数据
   * @returns
   */
  ChangeStatus(data) {
    return request({
      url: `${url}/changeStatus`,
      method: 'post',
      data
    })
  },
  /**
   * 审核
   * @returns
   */
  Audit(data) {
    return request({
      url: `${url}/audit`,
      method: 'post',
      data
    })
  },
  SiteList(data) {
    return request({
      url: `${url}/siteList`,
      method: 'post',
      data
    })
  },
  GetList(data) {
    return request({
      url: `${url}/getList`,
      method: 'post',
      data
    })
  },
  setAutoPlan(data) {
    return request({
      url: `${url}/setAutoPlan`,
      method: 'post',
      data
    })
  }
}

export default api
